export const GET_CREDIT_LIMIT_MODEL_SUCCESS = 'GET_CREDIT_LIMIT_MODEL_SUCCESS';
export const GET_CREDIT_LIMIT_MODEL_LIST = 'GET_CREDIT_LIMIT_MODEL_LIST';


export const getCreditLimitModelList =()=>{
    return{
        type:GET_CREDIT_LIMIT_MODEL_LIST
    }
}

export const getCreditLimitModelListSuccess =(data)=>{
    return{
        type:GET_CREDIT_LIMIT_MODEL_SUCCESS,
        data
    }
}

